import {
  ChangeDetectionStrategy,
  Component,
  computed,
  Inject,
  OnInit,
  Signal,
  signal,
  WritableSignal
} from '@angular/core';
import { IGetApplicationPageForm } from "../../../../rest-clients/application/forms/i-get-application-page.form";
import { IPage } from '@zaeper/communication-lib';
import { Button } from "primeng/button";
import {
  createLauncherModalServiceInjectionToken
} from "../../../../modals/create-launcher-modal/create-launcher-modal-service-injection-token";
import { ICreateLauncherModalService } from "../../../../modals/create-launcher-modal/i-create-launcher-modal.service";
import { ICreateLauncherModalOptions } from "../../../../modals/create-launcher-modal/i-create-launcher-modal.options";
import { launcherServiceInjectionToken } from "../../../../services/application/launcher/launcher-service-injection-token";
import { ILauncherService } from "../../../../services/application/launcher/i-launcher.service";
import { ILauncher } from "../../../../models/application/i-launcher";
import {
  CardComponent,
  ConfirmationModalService,
  confirmationModalServiceInjectionToken,
  ESeverity,
  IConfirmationModalService,
  IToastService,
  toastServiceInjectionToken
} from '@zaeper/angular-dashboard-view-lib';
import { ActivatedRoute, Data, Router } from "@angular/router";
import { ApplicationOverviewItemComponent } from "../../../../components/application-overview-item";
import { ConfirmationService } from "primeng/api";
import { launcherRestClientInjectionToken } from "../../../../rest-clients/application/launcher/launcher-rest-client-injection-token";
import { ILauncherRestClient } from "../../../../rest-clients/application/launcher/i-launcher-rest.client";

@Component( {
  selector: 'app-launchers-overview-tab-component',
  templateUrl: 'launchers-overview-tab.component.html',
  imports: [
    Button, CardComponent, ApplicationOverviewItemComponent
  ],
  providers: [
    {
      provide: confirmationModalServiceInjectionToken,
      useClass: ConfirmationModalService
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
} )
export class LaunchersOverviewTabComponent implements OnInit {
  private readonly _launcherPage$: WritableSignal<IPage<ILauncher> | undefined> = signal<IPage<ILauncher> | undefined>( undefined );
  protected launchers$: Signal<ILauncher[]> = computed( () => (this._launcherPage$()?.records) ?? [] );

  constructor(
    @Inject( createLauncherModalServiceInjectionToken ) private readonly _createLauncherModalService: ICreateLauncherModalService,
    @Inject( launcherServiceInjectionToken ) private readonly _launcherService: ILauncherService,
    @Inject( launcherRestClientInjectionToken ) private readonly _launcherRestClient: ILauncherRestClient,
    @Inject( toastServiceInjectionToken ) private readonly _toastService: IToastService,
    @Inject( confirmationModalServiceInjectionToken ) private readonly _confirmationModalService: IConfirmationModalService,
    private readonly _confirmService: ConfirmationService,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _router: Router
  ) {
  }

  ngOnInit() {
    this._activatedRoute.data.subscribe( ({ launcherPage }: Data) => {
      this._launcherPage$.set( launcherPage );
    } );
  }

  protected openCreateLauncherModal(): void {
    const options: ICreateLauncherModalOptions = {
      onConfirm: function (): void {
        throw new Error( 'Function not implemented.' );
      }
    };

    this._createLauncherModalService.open( options );
  }

  protected openLauncherDetailPage(launcherId: string): Promise<boolean> {
    return this._router.navigate( [ "de", "launcher", launcherId ] );
  }

  protected async deleteLauncher(
    event: Event,
    launcher: ILauncher
  ): Promise<void> {
    event.stopPropagation();

    const sendDeleteRequest = async () => {
      try {
        await this._launcherRestClient.deleteApplication( launcher.id );

        this._toastService.setMessage( {
          title: "Erfolgreich",
          detail: "Launcher wurde erfolgreich gelöscht.",
          severity: ESeverity.success
        } );

        await this._loadLauncherRecords();
      } catch ( e ) {
        this._toastService.setMessage( {
          title: "Fehler",
          detail: "Launcher konnte nicht gelöscht werden.",
          severity: ESeverity.error
        } );
      }
    };

    this._confirmationModalService.open( {
      title: `${ launcher.name } löschen?`,
      description: 'Dadurch werden auch alle veröffentlichten Versionen aus dem Store entfernt.',
      confirmationText: 'Löschen',
      onConfirm: () => sendDeleteRequest()
    } )
  }

  private async _loadLauncherRecords() {
    const form: IGetApplicationPageForm = {
      pageNumber: 0,
      pageSize: 100
    };

    const launcherPage: IPage<ILauncher> = await this._launcherService.getLauncherPage( form );
    this._launcherPage$.set( launcherPage );
  }
}
